<template>
  <v-row class="pt-5" v-if="doc">
    <v-col cols="10" offset="1">
      <v-row>
        <v-col cols="4">
          <p class="green--text headline mt-10">Box 1</p>
          <div v-html="doc.box1"></div>
        </v-col>
        <v-col cols="4">
          <p class="cyan--text headline mt-10">Box 2</p>
          <div v-html="doc.box2"></div>
        </v-col>
         <v-col cols="4">
          <p class="purple--text headline mt-10">Box 3</p>
          <div v-html="doc.box3"></div>
        </v-col>
         <v-col cols="4">
          <p class="pink--text headline mt-10">Box 4</p>
          <div v-html="doc.box4"></div>
        </v-col>
         <v-col cols="4">
          <p class="blue--text headline mt-10">Box 5</p>
          <div v-html="doc.box5"></div>
        </v-col>
         <v-col cols="4">
          <p class="light-green--text headline mt-10">Box 6</p>
          <div v-html="doc.box6"></div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsTrafficUser",
  data() {
    return {
      doc: null,
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise() {
      this.doc = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.blocksExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", this.uid);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0].doc;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
